import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";

function Service({color, classes = '', url  = ''}) {
    const navigate = useNavigate();
    const onMenuClick = () => {
        // navigate(`/${url}`);
    }
    return (
        <div className={classes} onClick={onMenuClick}>
            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 1H11V3H9V4.07089C12.3923 4.55612 15 7.47353 15 11H1C1 7.47353 3.60771 4.55612 7 4.07089V3H5V1Z" fill={color}/>
                <path d="M15 15V13H1V15H15Z" fill={color}/>
            </svg>
        </div>
    );
}

export default Service;
